import { convert as convertNumberToWordsRu } from 'number-to-words-ru';

/**
 * Преобразует числовое значение суммы в текстовое представление на русском языке БЕЗ слова "рублей".
 * Слово "рублей" должно выноситься за скобки и склоняться в зависимости от суммы.
 * @param {number|string} amount - Сумма для преобразования.
 * @returns {string} - Сумма прописью в формате "пятьдесят тысяч" или "один пятьдесят пять копеек" (без "рублей").
 */
const convertAmountToWords = (amount) => {
    if (!amount || isNaN(parseFloat(amount))) return '';
    try {
        const num = parseFloat(amount);
        const integerPart = Math.floor(num);
        const fractionalPart = Math.round((num - integerPart) * 100);
        
        // Преобразуем целую часть в слова БЕЗ настроек валюты (просто число)
        let integerWords = convertNumberToWordsRu(integerPart, {
            convertNumberToWords: {
                integer: true,
                fractional: false,
            },
        });
        
        // Очищаем от всех возможных лишних слов, цифр и символов
        let rublesText = integerWords.toLowerCase()
            .replace(/\d+/g, '') // Убираем ВСЕ цифры в первую очередь
            .replace(/\s*рубл[ьяей]+\s*/gi, ' ')
            .replace(/\s*копе[йе][каек]+\s*/gi, ' ')
            .replace(/\s*целых\s*\d*\s*десятых\s*/gi, ' ')
            .replace(/[^\p{L}\s]/gu, '') // Убираем все символы кроме букв и пробелов
            .replace(/\s{2,}/g, ' ')
            .trim();
        
        // НЕ добавляем "рублей" - оно будет вынесено за скобки
        let result = rublesText;
        
        // Добавляем копейки только если они есть (не 00)
        if (fractionalPart > 0 && fractionalPart < 100) {
            // Преобразуем копейки в слова БЕЗ настроек валюты (просто число)
            let kopecksWords = convertNumberToWordsRu(fractionalPart, {
                convertNumberToWords: {
                    integer: true,
                    fractional: false,
                },
            });
            
            // Очищаем от всех возможных лишних слов, цифр и символов
            let kopecksText = kopecksWords.toLowerCase()
                .replace(/\d+/g, '') // Убираем ВСЕ цифры в первую очередь
                .replace(/\s*рубл[ьяей]+\s*/gi, ' ')
                .replace(/\s*копе[йе][каек]+\s*/gi, ' ')
                .replace(/\s*целых\s*\d*\s*десятых\s*/gi, ' ')
                .replace(/[^\p{L}\s]/gu, '') // Убираем все символы кроме букв и пробелов
                .replace(/\s{2,}/g, ' ')
                .trim();
            
            // Получаем правильную форму слова "копейка"
            const kopecksForm = getKopecksForm(fractionalPart);
            
            // Добавляем копейки только если текст остался после очистки
            if (kopecksText && kopecksText.length > 0) {
                result += ` ${kopecksText} ${kopecksForm}`;
            }
        }
        
        return result;
    } catch (error) {
        console.warn('Ошибка преобразования числа в текст:', error);
        return '';
    }
};

/**
 * Функция для склонения слова "рубль" в зависимости от суммы.
 * @param {number|string} amount - Сумма (может быть числом или строкой).
 * @returns {string} - Правильная форма слова "рубль".
 */
const getRublesForm = (amount) => {
    if (!amount || isNaN(parseFloat(amount))) {
        return 'рублей'; // По умолчанию, когда сумма не введена
    }
    
    const num = Math.floor(parseFloat(amount));
    const lastDigit = num % 10;
    const lastTwoDigits = num % 100;
    
    if (lastTwoDigits >= 11 && lastTwoDigits <= 19) {
        return 'рублей';
    }
    if (lastDigit === 1) return 'рубль';
    if (lastDigit >= 2 && lastDigit <= 4) return 'рубля';
    
    return 'рублей';
};

/**
 * Функция для склонения слова "копейка" в зависимости от количества.
 * @param {number} kopecks - Количество копеек.
 * @returns {string} - Правильная форма слова "копейка".
 */
const getKopecksForm = (kopecks) => {
    const lastDigit = kopecks % 10;
    const lastTwoDigits = kopecks % 100;
    
    if (lastTwoDigits >= 11 && lastTwoDigits <= 19) {
        return 'копеек';
    }
    if (lastDigit === 1) return 'копейка';
    if (lastDigit >= 2 && lastDigit <= 4) return 'копейки';
    
    return 'копеек';
};

// Экспорт функций
export { convertAmountToWords, getRublesForm };